import { PayloadAction } from '@reduxjs/toolkit';

export interface WidgetData {
	id: string;
	domain: URL;
	image: URL;
	thumbnail: URL;
	bot: URL;
	botWidget?: string;
	language: string;
	text: string;
	position: WidgetPosition;
	multilingual?: boolean;
	name?: string;
	metaTitle?: string;
	metaDescription?: string;
	metaKeywords?: string;
	ogImageUrl?: string;
	faviconUrl?: string;
	themeColor?: string;
	canonicalUrl?: string;
	publisherUrl?: string;
	gtmId?: string;
	ga4Id?: string;
	texts?: Record<string, string>;
	initialQuestions?: Record<string, string[]>;
}

export interface CustomPosition {
	top: string;
	bottom: string;
	left: string;
	right: string;
	message: 'right' | 'left';
}

export enum PresetPosition {
	TopLeft = 'top-left',
	BottomLeft = 'bottom-left',
	TopRight = 'top-right',
	BottomRight = 'bottom-right'
}

export interface WidgetPosition {
	mobile: PresetPosition | CustomPosition;
	desktop: PresetPosition | CustomPosition;
}

export type WidgetAction = PayloadAction<WidgetData, 'widget/add-data'>; // ✅

export const setWidget = (widgetData: WidgetData): WidgetAction => ({
	type: 'widget/add-data',
	payload: widgetData
});
